<template name="createNewPage">
	<div>
    <div style="display: flex;justify-content: center;margin-bottom: 30px">
      <el-input style="width: 60%;margin-right: 10px"
                placeholder="输入页面名称"
                v-model="searchTitle"
                clearable>
      </el-input>
      <el-button icon="el-icon-search" circle @click="getProductTemplateList"></el-button>
    </div>
		<div style="display: flex; justify-content: center;">
			<div style="display: grid;grid-template-columns: 1fr 1fr 1fr;grid-gap: 40px;">
				<div style="height:300px;width:400px;background:#dddddd;display: flex;flex-direction: column;justify-content: center;align-items: center;"
					v-for="(listItem,listIndex) in  productTemplateList" :key="listIndex" @click="newProduct(listItem)">
                    <img :src="listItem.previewImg"  style="width: 100px;height: 100px;"/>
					<div class="grid-text">{{listItem.title}}</div>
				</div>
			</div>
		</div>
    <el-dialog title="新建草稿页面" :visible.sync="show">
      <el-form :model="productSaveForm">
        <el-form-item label="标题" label-width="120px">
          <el-input v-model="productSaveForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" label-width="120px">
          <el-input v-model="productSaveForm.description" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show=false">取 消</el-button>
        <el-button type="primary" @click="show=false;saveProduct();">确 定</el-button>
      </div>
    </el-dialog>
	</div>
</template>

<script>
	import DOMAIN_PREFIX from "@/../config/domainPrefix.js"
	const AVATAR_PREFIX = DOMAIN_PREFIX.AVATAR_PREFIX
  import API from "@/../config/api.js";
  import IMGURL from "@/../config/imgUrl.js";
	export default {
		name: "createNewPage",
		data() {
			return {
				userId: '',
				logoImg: IMGURL.logoImgUrl, //logo图片
				logoHome: IMGURL.logoHome,
				productTemplateList: [], //存放模板列表
				searchTitle: '', //搜素模板名
				show: false, //模态窗的展示
				productSaveForm: {
					title: "", // 标题
					description: "", // 描述
					projectId: "", // 该页面所属项目id
					product_type: 0, //页面类型
				},
				templateItem: {}, //记录选中的是第几个
				errorType: ['message'],
				productId: '', //页面id
			}
		},
		mounted() {
			this.getProductTemplateList() //获取模板列表
			this.userId = window.localStorage.getItem('userid');
		},
		props: {
			companyId: Number,
			projectId: Number,
		},
		methods: {
			async getProductTemplateList() {
				console.log('开始获取模板列表')
				let data = await this.$axiosRequest({
              url: API.getProductTemplateList,
              method: 'POST',
              data: {
                companyId: this.companyId,
                title: this.searchTitle
              },
            }
				)
        console.log(data);
				this.productTemplateList = data[1].data.productTemplateList;
				console.log('模板列表this.productTemplateList=', this.productTemplateList)
				for (let i = 0; i < this.productTemplateList.length; i++) {
					this.productTemplateList[i].previewImg = AVATAR_PREFIX + this.productTemplateList[i].previewImg
					console.log('模板列表this.productTemplateList图片=', this.productTemplateList[i].previewImg)
				}
			},
			newProduct(item) {
				console.log(item);
				this.show = true;
				//渲染表单规则
				this.templateItem = item;

				this.productSaveForm.product_type = item.product_type;
			},
			clear() {
				this.getProductTemplateList();
			},
			saveProduct() { //后期根据后端接口进行修改
        if(!this.productSaveForm.title){
          this.$message({
            message: '请输入标题！',
            type: 'warning'
          })
          return;
        }

        let compsJson = {};
        if (this.templateItem.tableData) {
          compsJson = JSON.parse(this.templateItem.tableData)
        }

        // 保存页面
        let header1 = {
          "Content-Type": "application/x-www-form-urlencoded"
        }
        console.log("新建草稿")
        let data1 = {
          companyId: this.companyId,
          product_type: this.productSaveForm.product_type,
          title: this.productSaveForm.title,
          projectId: this.projectId,
          description: this.productSaveForm.description,
          authorId: this.userId, // 【改为后台获取当前用户id】
          tableData: JSON.stringify(compsJson),
        }
        console.log(data1);
        this.$axiosRequest({
          url: API.addProduct,
          method: 'POST',
          data: data1,
          header: header1,
          success: res => {
            if (res.status == 200) {
              if (res.data == 0) {
                this.$message({
                  message: '已存在该标题页面！',
                  type: 'warning'
                })
              } else if (res.data == -1) {
                this.$message({
                  message: '后台错误，未保存成功，请重试！',
                  type: 'warning'
                })
              } else if (res.data > 0) {
                console.log("保存成功 草稿id = ", res.data)
                this.productId = res.data
                console.log('eeeeeeeeeeee', this.productId)
                this.$message({
                  message: '创建成功',
                  type: 'success'
                })
                let startparam = { //向外传递的参数
                  productId: this.productId,
                  authorId: this.userId,
                  companyId: this.companyId,
                  title: this.productSaveForm.title,
                  projectId: this.projectId,
                  description: this.productSaveForm.description,
                  uniqueId: 'Product_' + this.productId,
                }
                switch (this.productSaveForm.product_type) {
                    //普通页面
                  case 0: {
                    startparam.stageType = 3
                    break;
                  }
                    //地图
                  case 1: {
                    startparam.stageType = 20
                    break;
                  }
                    //报警、历史
                  case 2: {
                    startparam.stageType = 21
                    break;
                  }
                  case 3: {
                    startparam.stageType = 22
                    break;
                  }
                }

                this.show = false
                this.$emit('add', startparam);
              }
            }
          }
        })
			},
		},

	}
</script>

<style>

	.info-card {
		margin: 10px 15px 10px 15px;
		padding: 12px;
	}

	image {
		width: 60px;
		flex: 0 0 60px;
		height: 60px;
		margin-right: 10px;
		border-radius: 6px;
	}

	.slot-content {
		color: blue;
	}

	.grid-text {
		font-size: 20px;
		font-weight: bold;
		color: #000000;
		padding: 5px 0 10px 0;
		box-sizing: border-box;
	}
</style>
